import type { FaireProductEntity } from "../../entity_types/product";

export const p_y4vcvmvtzr: FaireProductEntity = {
  token: "p_y4vcvmvtzr",
  type: "product",
  name: "Spirit Candle",
  brandToken: "b_4j1osx4h0b",
  brandName: "Shaman's Dawn",
  imageUrl: "https://cdn.faire.com/fastly/4940cbfceb1a94cdf37aed722b0c68aa45dd60af2f893d1f436d232dfb8d7347.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/27a369efe620fbebcdd46f7799bb2b4550e55c9324e87167cddf99c4bbb023e9.png",
    "https://cdn.faire.com/fastly/6f6967fbd46102d61a51ced3a7b4cac39790169d4d2c938d1370f6334dfc6863.jpeg"
  ],
  priceDollars: 9.5,
  description: "Soy wax intention candle for meditation, spiritual connection, and guidance\n\nMade with Essential Oils of: Frankincense, Lavender, Neroli, and Basil\n\nScent: Resinous frankincense with hints of sweet floral\n\nColor: Indigo\n\nUse for: inviting in the energies of the divine and the helping spirits, connecting to guides and angels, and to aid in spiritual work and meditation.\n\nHand made with 100% Soy Wax and shamanically charged with prayer and intention\n\nShamans Dawn jar candles are hand made, contain essential oils, and are energetically charged with their healing intentions. This is done through prayer and shamanic ceremony to ask for the aid of helping spirits. Light a candle and set your intention or prayer to help manifest changes in your life. Each candle is labeled with a shamanic healing symbol that embodies the healing intentions of the candles.\n\nGlass jars are 5 inches tall and 2.25 inches in diameter and 8oz in volume\n\n100% Soy Wax, Lead free cotton wicks, essential oils and fragrance oils\n\nBurn Time: approx 50 hours\n\nOur candles are hand poured with 100% soy wax to encourage sustainable and environmentally conscious alternatives for candles.\n\n\n",
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:04.307Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
